import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth/services/auth-guard.service';
import { HeaderComponent } from '@core/components';
import { NotFoundComponent } from '@core/containers';
import { RouteEntity } from '@core/router/router.entity';


export const routes: Routes = [
    {
        path: RouteEntity.Empty,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: RouteEntity.Topup,
                loadChildren: () => import('@feature/top-up/top-up.module').then((m) => m.TopUpModule),
                canActivate: [AuthGuard],
            },
            {
                path: RouteEntity.Tickets,
                loadChildren: () => import('app/feature/tickets/tickets.module').then((m) => m.TicketsModule),
                canActivate: [AuthGuard],
            },
            {
                path: RouteEntity.Services,
                loadChildren: () => import('app/feature/products/products.module').then((m) => m.ProductsModule),
            },
            {
                path: RouteEntity.History,
                loadChildren: () => import('app/feature/history/history.module').then((m) => m.HistoryModule),
            },
            {
                path: RouteEntity.Person,
                loadChildren: () => import('app/feature/person/person.module').then((m) => m.PersonModule),
            },
            {
                path: RouteEntity.Map,
                loadChildren: () => import('app/feature/map/map.module').then((m) => m.MapModule),
            },
            {
                path: RouteEntity.Support,
                loadChildren: () => import('app/feature/support/support.module').then((m) => m.SupportModule),
            },
            {
                path: RouteEntity.Coupon,
                loadChildren: () => import('app/feature/coupon/coupon.module').then((m) => m.CouponModule),
            },
            {
                path: RouteEntity.Basket,
                loadChildren: () => import('app/feature/basket/basket.module').then((m) => m.BasketModule),
                canActivate: [AuthGuard],
            },
            {
                path: RouteEntity.Medium,
                loadChildren: () => import('app/feature/cards/cards.module').then((m) => m.CardsModule),
            },
            {
                path: 'payment-web',
                loadChildren: () => import('app/feature/basket/basket.module').then((m) => m.BasketModule),
            },
            { path: RouteEntity.Empty, redirectTo: RouteEntity.Tickets, pathMatch: 'full' },
        ],
    },
    {
        path: RouteEntity.Logout,
        canActivate: [AuthGuard],
        loadChildren: () => import('app/feature/logout/logout.module').then((m) => m.LogoutModule),
    },
    {
        path: RouteEntity.PrivacyPolicy,
        loadChildren: () => import('app/feature/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
    },
    {
        path: RouteEntity.TermsOfUse,
        loadChildren: () => import('app/feature/terms-of-use/terms-of-use.module').then((m) => m.TermsOfUseModule),
    },
    { path: '**', component: NotFoundComponent },
    { path: RouteEntity.Empty, outlet: 'header', component: HeaderComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: false,
            enableTracing: false,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
